import { readRemoteSession } from "../context/RemoteLaunchContext";

/**
 * Is this session being played on the web rather than at a kiosk?
 *
 * A remote launch — the app running from an external page or a standalone web
 * link — is web play. Anything else is a kiosk in a venue.
 *
 * The distinction matters wherever a rule is really about the *machine* rather
 * than the game. Idle timeouts are the clearest case: a kiosk is shared, so an
 * abandoned session holds a physical terminal and has to be reclaimed quickly.
 * A player on their own phone is blocking nobody, and timing them out mid-think
 * costs them a pick and makes them identify themselves all over again.
 *
 * One helper rather than a readRemoteSession() check at each site, so "what
 * counts as web play" has a single answer.
 */
export function isWebPlay(){
    var remote = readRemoteSession();
    return !!(remote && remote.isRemote);
}
